// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__lALu_","ldsRing":"Loader_ldsRing___mayq","lds-ring":"Loader_lds-ring__wfIbW"};